import styled from "styled-components";

export const StyledWrapper = styled.div`
  position: relative;
  z-index: ${({ depthlevel }) => `calc(4 - ${depthlevel})`};

  ${({ theme }) => theme.media.onlyMobile`
    width: ${({ depthlevel }) => `calc(100% - 5% * ${depthlevel}) !important`};
    margin-bottom: ${({ showreplies }) => (showreplies ? "0" : "40px")};
  `}

  >div:first-child {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;

    ${({ theme }) => theme.media.onlyMobile`
      width: 100%;
      align-items: flex-start;
    `}

    >div:last-child {
      height: 100%;
    }
  }
  > div:nth-child(2) {
    width: ${({ depthlevel }) => `calc(75% - 128px * ${depthlevel})`};

    ${({ theme }) => theme.media.onlyMobile`
      width: calc(100% - 30px);
      align-self: flex-end;
      position: relative;
    `}
  }
`;

export const StyledCommentBody = styled.div`
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.neutralsWhite};
  padding: 18px 21px 18px 24px;
  color: ${({ theme }) => theme.colors.neutralsTextLight};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  > span:first-child {
    color: ${({ theme }) => theme.colors.neutralsText};
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const StyledCommentsBodyWrapper = styled.div`
  ${({ theme }) => theme.media.exceptMobile`
    margin-bottom: 40px;
  `}

  >div:last-child {
    margin-top: 8px;
    margin-left: 24px;
    margin-right: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    ${({ theme }) => theme.media.onlyMobile`
      flex-direction: column;
      align-items: flex-start;
    `}

    >div>a {
      &:first-child {
        margin-left: 0;
      }
      margin-left: 24px;

      > img {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

export const StyledReplyActionContainer = styled.div`
  > div:first-child {
    height: ${({ showreplies }) =>
      showreplies ? "100%" : "calc(100% - 67px)"};
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    transition: height 0.5s;

    > div:first-child {
      margin-top: 3.5px;
      margin-right: 32px;
      width: 1px;
      height: calc(100% - 41px);
      background: ${({ theme }) => theme.colors.primaryRulerTint50};
    }
    > div:last-child {
      margin-right: 21px;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
    }
  }
`;

export const StyledRepliesWrapper = styled.div`
  visibility: ${({ showreplies }) => (showreplies ? "visible" : "hidden")};
  transition: max-height 0.5s;
`;

export const StyledVericalReplyLine = styled.div`
  position: absolute;
  top: 0;
  left: -15px;
  width: 1px;
  height: 100%;
  background: ${({ theme }) => theme.colors.primaryRulerTint50};
`;
